import React from 'react';

import InputField from '../inputField/InputField';
import { useTranslation } from 'react-i18next';
import { type User } from '../../api/types/index';

type PlaylistGroupFormProps = {
    user?: User;
    title: string;
    onTitleChange: (value: string) => void;
};

const PlaylistGroupForm = ({
    title,
    onTitleChange
}: PlaylistGroupFormProps) => {
    const { t } = useTranslation();
    return (
        <div className="playlist-form-container">
            <InputField
                isFocusDisabled
                label={t('title')}
                name="title"
                onValueChangeHandler={onTitleChange}
                value={title}
            />
        </div>
    );
};

export default PlaylistGroupForm;
